import { createContext } from 'react'

const CategoryDetailsContext = createContext()

export default CategoryDetailsContext
